/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Storage variant (one of local or distributed).
 */
export var StorageVariant = /*#__PURE__*/function (StorageVariant) {
  StorageVariant["DISTRIBUTED"] = "distributed";
  StorageVariant["LOCAL"] = "local";
  return StorageVariant;
}(StorageVariant || {});

